export const routes = [
  {
    "slug": "2025-consumer-insights-report",
    "path": "/home-insurance/2025-consumer-insights-report"
  },
  {
    "slug": "80-percent-rule",
    "path": "/home-insurance/80-percent-rule"
  },
  {
    "slug": "auto-insurance-the-state-of-auto-insurance-in-2025",
    "path": "/auto-insurance/auto-insurance-the-state-of-auto-insurance-in-2025"
  },
  {
    "slug": "average-mileage-per-year",
    "path": "/auto-insurance/average-mileage-per-year"
  },
  {
    "slug": "best-and-worst-cities-for-car-owners-in-summer",
    "path": "/auto-insurance/best-and-worst-cities-for-car-owners-in-summer"
  },
  {
    "slug": "bundle-home-auto-insurance",
    "path": "/home-insurance/bundle-home-auto-insurance"
  },
  {
    "slug": "clogged-sewer-line",
    "path": "/utility-line-warranty/clogged-sewer-line"
  },
  {
    "slug": "declaration-page",
    "path": "/home-insurance/declaration-page"
  },
  {
    "slug": "drunk-driving-fatalities-by-state",
    "path": "/home-insurance/drunk-driving-fatalities-by-state"
  },
  {
    "slug": "dui-meaning",
    "path": "/auto-insurance/dui-meaning"
  },
  {
    "slug": "economic-stress-delaying-purchases",
    "path": "/home-insurance/economic-stress-delaying-purchases"
  },
  {
    "slug": "economic-uncertainty-delaying-home-upgrades",
    "path": "/home-insurance/economic-uncertainty-delaying-home-upgrades"
  },
  {
    "slug": "first-time-home-buyer-insurance",
    "path": "/home-insurance/first-time-home-buyer-insurance"
  },
  {
    "slug": "first-time-homebuyer-nightmares",
    "path": "/home-insurance/first-time-homebuyer-nightmares"
  },
  {
    "slug": "flood-insurance",
    "path": "/home-insurance/flood-insurance"
  },
  {
    "slug": "full-coverage-car-insurance",
    "path": "/auto-insurance/full-coverage-car-insurance"
  },
  {
    "slug": "gap-insurance",
    "path": "/auto-insurance/gap-insurance"
  },
  {
    "slug": "home-insurance-2025-rate-increase",
    "path": "/home-insurance/home-insurance-2025-rate-increase"
  },
  {
    "slug": "home-insurance-statistics",
    "path": "/home-insurance/home-insurance-statistics"
  },
  {
    "slug": "homeowners-insurance-awareness",
    "path": "/home-insurance/homeowners-insurance-awareness"
  },
  {
    "slug": "homeowners-insurance-knowledge-survey",
    "path": "/home-insurance/homeowners-insurance-knowledge-survey"
  },
  {
    "slug": "homeowners-insurance-preparedness-survey",
    "path": "/home-insurance/homeowners-insurance-preparedness-survey"
  },
  {
    "slug": "house-fire-statistics",
    "path": "/home-insurance/house-fire-statistics"
  },
  {
    "slug": "how-home-age-impacts-insurance",
    "path": "/home-insurance/how-home-age-impacts-insurance"
  },
  {
    "slug": "how-to-file-home-insurance-claim",
    "path": "/home-insurance/how-to-file-home-insurance-claim"
  },
  {
    "slug": "hurricane-damage-statistics",
    "path": "/home-insurance/hurricane-damage-statistics"
  },
  {
    "slug": "hurricane-season-insurance-guide",
    "path": "/home-insurance/hurricane-season-insurance-guide"
  },
  {
    "slug": "insurance-perils",
    "path": "/home-insurance/insurance-perils"
  },
  {
    "slug": "is-it-illegal-to-drive-barefoot",
    "path": "/auto-insurance/is-it-illegal-to-drive-barefoot"
  },
  {
    "slug": "landlord-insurance",
    "path": "/home-insurance/landlord-insurance"
  },
  {
    "slug": "least-resilient-coastal-cities",
    "path": "/home-insurance/least-resilient-coastal-cities"
  },
  {
    "slug": "liability-insurance",
    "path": "/auto-insurance/liability-insurance"
  },
  {
    "slug": "non-owner-car-insurance",
    "path": "/auto-insurance/non-owner-car-insurance"
  },
  {
    "slug": "north-carolina-climate-risk-and-resilience",
    "path": "/home-insurance/north-carolina-climate-risk-and-resilience"
  },
  {
    "slug": "north-carolina-home-insurance",
    "path": "/home-insurance/north-carolina-home-insurance"
  },
  {
    "slug": "raleigh",
    "path": "/blog/raleigh"
  },
  {
    "slug": "skipping-maintenance-insurance-risk",
    "path": "/home-insurance/skipping-maintenance-insurance-risk"
  },
  {
    "slug": "summer-road-trip-readiness",
    "path": "/home-insurance/summer-road-trip-readiness"
  },
  {
    "slug": "tesla-owners-insurance-costs-electric-car-risks",
    "path": "/auto-insurance/tesla-owners-insurance-costs-electric-car-risks"
  },
  {
    "slug": "trust-ai-home-advice",
    "path": "/home-insurance/trust-ai-home-advice"
  },
  {
    "slug": "umbrella-policy",
    "path": "/umbrella-insurance/umbrella-policy"
  },
  {
    "slug": "uninsured-motorist-coverage",
    "path": "/auto-insurance/uninsured-motorist-coverage"
  },
  {
    "slug": "utility-line-warranty-flushed-funds-report",
    "path": "/home-insurance/utility-line-warranty-flushed-funds-report"
  },
  {
    "slug": "water-damage-statistics",
    "path": "/home-insurance/water-damage-statistics"
  },
  {
    "slug": "what-does-renters-insurance-cover",
    "path": "/home-insurance/what-does-renters-insurance-cover"
  }
];
